import { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/core/auth/useAuth";

interface KioskRouteProps {
  children: ReactNode;
}

/**
 * Route guard per pagine kiosk. A differenza di ProtectedRoute,
 * redirige a /device (PIN login) invece di /auth (login principale).
 */
const KioskRoute = ({ children }: KioskRouteProps) => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/device", { replace: true });
    }
  }, [user, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-black" />
      </div>
    );
  }

  if (!user) return null;

  return <>{children}</>;
};

export default KioskRoute;
